import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableFooterExportComponent } from './table-footer-export.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [TableFooterExportComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [TableFooterExportComponent]
})
export class TableFooterExportModule { }
